export var HostRunStatus;
(function (HostRunStatus) {
    HostRunStatus[HostRunStatus["Pending"] = 0] = "Pending";
    HostRunStatus[HostRunStatus["Running"] = 10] = "Running";
    HostRunStatus[HostRunStatus["Finished"] = 20] = "Finished";
    HostRunStatus[HostRunStatus["Cancelled"] = 90] = "Cancelled";
    HostRunStatus[HostRunStatus["Failed"] = 100] = "Failed";
})(HostRunStatus || (HostRunStatus = {}));
